export const SET_AUTH_USER = 'SET_AUTH_USER'
export const SET_USER_LOGIN = 'SET_USER_LOGIN'
export const UPDATE_USER_PASSWORD_REQUEST = 'UPDATE_USER_PASSWORD_REQUEST'
export const UPDATE_USER_PASSWORD_SUCCESS = 'UPDATE_USER_PASSWORD_SUCCESS'
export const UPDATE_USER_PASSWORD_FAILURE = 'UPDATE_USER_PASSWORD_FAILURE'
export const SET_PERMISSIONS = 'SET_PERMISSIONS'
